import { useRef } from "react";
import { CSSTransition } from "react-transition-group";
import styles from "./Radio.module.scss";
import CheckmarkIcon from "./checkmark.svg?react";
import cn from "classnames";

interface RadioProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  title?: string;
  description?: string;
  error?: boolean;
  isBlock?: boolean;
}

const Radio = ({ checked, onChange, disabled, title, description, error, isBlock }: RadioProps) => {
  const radioRef = useRef(null);

  const handleChange = () => {
    if (!disabled && onChange) onChange(!checked);
  }

  return (
    <div className={cn(
      styles.root,
      checked === true && styles.checked,
      error && styles.error,
      disabled && styles.disabled,
      isBlock && styles.block,
    )}>
      <label className={styles.label}>
        <input
          type="radio"
          checked={checked}
          onChange={handleChange}
        />
        <div className={styles.radio}>
          <CSSTransition
            nodeRef={radioRef}
            in={Boolean(checked)}
            out="true"
            timeout={500}
            mountOnEnter
            classNames={{
              enter: styles.radioIconEnter,
              enterActive: styles.radioIconEnterActive,
              exit: styles.radioIconExit,
              exitActive: styles.radioIconExitActive,
              exitDone: styles.radioIconExitDone,
            }}
          >
            <div ref={radioRef} className={styles.radioIcon}>
              <CheckmarkIcon />
            </div>
          </CSSTransition>
        </div>
        {isBlock ? (
          <div className={styles.titleContainer}>
            <span className={styles.title}>{title}</span>
            {description ? (<span className={styles.description}>{description}</span>) : false}
          </div>
        ) : (title ? (
          <span className={styles.title}>{title}</span>
        ) : null)}

      </label>
    </div>
  );
};

export default Radio;
